import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import ShoppingCartInfo from '../../components/ShoppingCart/ShoppingCartInfo'

const ShoppingCartInfoPage = () => {
    return (
        <>
            <Helmet>
                <title>Cart Info</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <ShoppingCartInfo />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ShoppingCartInfoPage